module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.6e4a1089.mp3";